import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { writeMessageActions } from "../../_store";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SelectInput } from "../../components/common/UI/Inputs/InputControls";
import EmojiPicker from "../../components/common/EmojiPicker";
import {
  restrictCharacters,
  getGraphemes,
  isEmoji,
} from "../../utils/keywordBlocker";
import { useRef } from "react";
import { useCallback } from "react";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup";
import sendEcardSchema from "../../validation/WriteEcardSchema";
import useFullPageLoader from "../../hooks/useFullPageLoader";
// import NotificationService from "../../../src/ui/ui-modal-notification.js";
import NotificationService from "../../../src/ui/ui-modal-notification.js";
import { ReactNotifications } from "react-notifications-component";
import { sendPhotosActions } from "../../_store";
import { CreateEventLogTextFileForInbox } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import CustomPhoto from "../../components/Image/ZoomRotateImage.jsx";
import GraphemeSplitter from 'grapheme-splitter';
import useCheckQuarantineWords from "../../hooks/useCheckQuarantineWords.jsx";
import TranslateFile from "../../config/TranslateFile.jsx";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";
import { checkEmojiRegex, commonemojiRegex, getDifference } from "../../components/common/emoji-whitelist.js";
import CustomEcard from "../../components/Image/CustomEcard.jsx";

const SendECard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [ecardInfo, setEcardInfo] = useState({});
  const location = useLocation();
  const card = location.state?.card;
  const [EcardInmateID, setEcardInmateID] = useState(location.state?.EcardInmateID);
  const [inmateList, setInmateList] = useState([]);
  const emojiPickerRef = useRef(null);
  const subjectInputRef = useRef(null);
  const [isSubjectIconPickerOpen, setIsSubjectIconPickerOpen] = useState(false);
  const [isSubjectFocused, setIsSubjectFocused] = useState(false);
  const [errors, setErrors] = useState();
  const isInsertingFromPicker = useRef(false);
  const userID = getStoredValue("userID");
  const [selectedInmateInfo, setSelectedInmateInfo] = useState();
  const [msgCreditamount, setMsgCreditamount] = useState("");
  const [showCreditsAndMessageCost, setShowCreditsAndMessageCost] =
    useState(false);
  const [keywords, setKeywords] = useState([]); // State used for store admin restricted keywords
  const [isCreditamountModal, setisCreditamountModal] = useState(false);
  const [ecardCost, setEcardCost] = useState();
  const [keywordPopup, setKeywordPopup] = useState(false);
  const [foundKeyword, setFoundKeyword] = useState("");
  const [SendEcardConfirmation, setSendEcardConfirmation] = useState(false); // Ecard - Confirmation Popup
  const [shouldDisplayHTMLMessage, setShouldDisplayHTMLMessage] =
    useState(false);
  const [paymentMsg, setPaymentMsg] = useState("");
  const [isPaymentMsg, setIsPaymentMsg] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [loading, setLoading] = useState(false);
  // const prevValueRef = useRef("");
  // const inmateList = useSelector((state) => state?.writeMessage?.inmateList || []);
  const MsgPhotoStatusResponse = useSelector(
    (state) => state.sendPhotos.CheckingMsgPhotoStatusResponse
  );
  const currentLang = TranslateFile();
  const prevValueRef = useRef("");
  const lastKeyRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [customized, setCustomized] = useState(false);
  const [envelopecolor, setenvelopecolor] = useState("");
  const [ecardbgcolor, setecardbgcolor] = useState("");
  const [rippencolor, setrippencolor] = useState("");

  const initialSendEcard = {
    publicUserID: getStoredValue("userID"),
    inmateID: 0,
    facilityId: 0,
    ecardId: 0,
    eCardName: "",
    ecardSubject: "",
    isEmojiUsed: false,
    totalEmojiCost: 0,
    totalEcardCost: 0,
  };

  const initialCreditBalance = {
    CreditBalance: 0.0,
    FacilityEmojiCost: 0.0,
    FacilityID: null,
    FacilityMessageCost: 0.0,
    FacilityPhotoCost: 0.0,
    FacilityEcardCost: 0.0,
    InmateStatus: -1,
    IsEmojiEnabled: false,
  };
  const [selectinmateId, setSelectInmateId] = useState();
  const [ecard, setEcard] = useState(initialSendEcard);
  const [creditBalance, setCreditBalance] = useState(initialCreditBalance);
  const LoadQuarantineWords = useCheckQuarantineWords();

  const handleBackClick = () => {
    navigate("/public/WriteMessage", { state: { activeTab: "ecard", isshowalert: false, isEcardtoBack: true } });
  };

  // Load E-card categories
  useEffect(() => {
    let isMounted = true;
    if (card?.EcardId) {
      setEcard((preState) => ({
        ...preState,
        ecardId: card?.EcardId,
        eCardName: card?.EcardName
      }));
      showLoader();
      dispatch(writeMessageActions.LoadEcardForPublicUserDetails(card?.EcardId))
        .then((res) => {
          hideLoader();
          if (res.payload == "") {
            navigate("/public/WriteMessage", { state: { activeTab: "ecard", isshowalert: true } });
          }
          setEcardInfo(res?.payload || []);

          if (location.state?.EcardInmateID) {
            setEcard((prevState) => ({
              ...prevState,
              ["inmateID"]: EcardInmateID,
            }));
            setEcardInmateID(location.state?.EcardInmateID);
            setSelectInmateId(location.state?.EcardInmateID);
            dispatch(
              writeMessageActions.getCategoryPublicCreditBalance({
                userId: userID,
                inmatesId: EcardInmateID,
                CategoryId: ecardInfo?.CategoryId || res?.payload?.CategoryId,
              })
            ).then((response) => {
              if (response?.meta?.requestStatus === "fulfilled") {
                // The action was successful
                setShowCreditsAndMessageCost(true);
                let data = response?.payload;
                const formattedBalance = Object.keys(data).reduce((acc, key) => {
                  acc[key] =
                    typeof response?.payload[key] === "number" ||
                      !isNaN(response?.payload[key])
                      ? formatToTwoDecimals(response?.payload[key])
                      : response.payload[key];
                  return acc;
                }, {});

                let formatValue = formattedBalance[0];

                setEcard((prevState) => ({
                  ...prevState,
                  facilityId: formatValue?.FacilityID,
                }));
                let ECardCost = formatValue?.CategoryCost != 0 ? formatValue?.CategoryCost : formatValue?.FacilityEcardCost

                if (formatValue?.CreditBalance === 0) {
                  setisCreditamountModal(true);
                  setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Card);
                }
                if (

                  formatValue?.CreditBalance < ECardCost
                ) {
                  setisCreditamountModal(true);
                  setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Card);
                }
                setCreditBalance({
                  ...formatValue,
                  CreditBalance: parseFloat(formatValue?.CreditBalance ?? 0),
                  FacilityEmojiCost: parseFloat(
                    formatValue?.IsEmojiEnabled
                      ? formatValue?.FacilityEmojiCost ?? 0
                      : 0
                  ),
                  FacilityMessageCost: parseFloat(
                    formatValue?.FacilityMessageCost ?? 0
                  ),
                  FacilityPhotoCost: parseFloat(formatValue?.FacilityPhotoCost ?? 0),
                  FacilityEcardCost: parseFloat(ECardCost ?? 0),
                  IsEmojiEnabled: formatValue?.IsEmojiEnabled ?? false,
                });
                setEcardCost(
                  formatValue?.CategoryCost?.toFixed(2) > 0
                    ? formatValue?.CategoryCost?.toFixed(2)
                    : parseFloat(ECardCost ?? 0)
                );
              } else {
                // The action failed
                // console.error("Error:", response.error.message);
              }
            });
          }


        })
        .catch((error) => {
          hideLoader();
          if (isMounted) {
            console.error("Failed to load eCard categories:", error);
            setEcardInfo([]);
          }
        });
    }


    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  // Load Inmate List ------------------------------------
  useEffect(() => {
    let isMounted = true;

    let data = {
      publicUserID: userID,
      inmateID: 0,
      connectionStatus: 2,
      purpose: "Ecard",
      sortBy: "",
    };
    dispatch(writeMessageActions.LoadPublicMyContactsDisplayEcard(data))
      .then((res) => {
        setInmateList(res?.payload || []);
      })
      .catch((error) => {
        if (isMounted) {
          console.error("Failed to load Inmate List:", error);
          setInmateList([]);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  const handleKeyDownPhoto = (event) => {
    lastKeyRef.current = event.key;
    if (event.key === "Enter") {
      event.preventDefault();
      // handlePhotoSendValidation(); ----------------------------------------------------- Need to call Validation here
    }
    if (event.key === "Meta") {
      // setDisableInput(true); // Disable input while the Windows key is held
      event.target.blur();
    }
  };

  // Removes the "border-danger" class from the specified field to clear validation styling, if it exists.
  const removeFieldValidationByName = (fieldName) => {
    const field = document.querySelector(`[name="${fieldName}"]`);
    if (field && field.classList.contains("border-danger")) {
      field.classList.remove("border-danger");
    }
  };

  const findGraphemeClusters = (input) => {
    const splitter = new GraphemeSplitter();
    const graphemes = splitter.splitGraphemes(input);
    let index = 0;
    const segments = graphemes.map(grapheme => {
      const segmentInfo = {
        segment: grapheme,
        index: index,
        input: input
      };
      index += grapheme.length;
      return segmentInfo;
    });

    return segments;
  };

  const handleInputClick = (e) => {
    const { target } = e;
    const inputValue = target.value;
    const caretPosition = target.selectionStart;
    const graphemes = findGraphemeClusters(inputValue);
    let graphemeIndex = 0;
    for (let i = 0; i < graphemes.length; i++) {
      if (graphemes[graphemes.length - 1].index < caretPosition) {
        graphemeIndex = caretPosition;
        break;
      }
      else if (graphemes[i].index == caretPosition) {
        graphemeIndex = i;
        break;
      }
    }
    setCursorPosition(graphemeIndex);
  };

  const handleChange = (e, isMessage) => {
    let { name, value, selectionStart, selectionEnd } = e.target;
    const prevValue = prevValueRef.current;
    const key = lastKeyRef.current;
    const wasAdded = value.length > prevValue.length;

    const currentAddValue = getDifference(value, prevValue);

    let chars = getGraphemes(currentAddValue);

    // Mobile Emoji Removed
    if (chars?.length == 1 && currentAddValue.match(emojiRegex)) {
      return;
    }

    // Public User - Write Message / inbox / Archived - Unable to enter the emoji in between existing text
    // if (key !== "Backspace" ) {
    //   // 🔍 Detect the last typed character
    //   let lastTypedChar = "";
    //   if (wasAdded && selectionStart != null) {
    //     const insertedLength = value.length - prevValue.length;
    //     lastTypedChar = value.substring(selectionStart - insertedLength, selectionStart);
    //   }

    //   // Default to actual input caret if not passed
    //   const splitter = new GraphemeSplitter();
    //   const graphemes = splitter.splitGraphemes(prevValue);
    //   const updatedGraphemes = [
    //     ...graphemes.slice(0, cursorPosition),
    //     lastTypedChar,
    //     ...graphemes.slice(cursorPosition)
    //   ];
    //   const updatedValue = updatedGraphemes.join('');
    //   value = updatedValue;
    //   setCursorPosition(cursorPosition + 1);
    // }

    prevValueRef.current = value;

    removeFieldValidationByName(name);

    setErrors((prev) => ({
      ...prev,
      [name]: "", // Clear the specific field error
    }));
    // value = value.trimStart();
    // value = value.replace(/\s+/g, " ");
    if (getDisplayLength(value) <= 50) {
      setEcard((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setEcard((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubjectFocus = () => {
    setIsSubjectFocused(true);
  };

  const handleIconClick = (field) => {
    if (field === "subject") {
      setIsSubjectIconPickerOpen((prevState) => !prevState);
      subjectInputRef?.current?.focus();
    }
  };

  const handleSubjectBlur = (e) => {
    // Check if the blur event is triggered by the emoji picker
    if (
      emojiPickerRef.current &&
      emojiPickerRef.current.contains(e.relatedTarget)
    ) {
      return; // Don't close the emoji picker if the click is inside it
    }

    setIsSubjectFocused(false);
    // setIsSubjectIconPickerOpen(false); // Close the emoji picker
  };

  // Known compound emojis that require special handling
  const compoundEmojis = ["🤷‍♀️", "🤷‍♂️"];

  // Regex to match both single emojis and compound emojis with ZWJ
  // const emojiRegex =
  //   /(\p{Extended_Pictographic}(\u200D\p{Extended_Pictographic})*)/gu;
  const emojiRegex = commonemojiRegex();

  // Function to count emojis as single units and other characters normally
  const getDisplayLength = useCallback(
    (text) => {
      // Count compound emojis explicitly
      let compoundEmojiCount = 0;
      compoundEmojis.forEach((emoji) => {
        const compoundRegex = new RegExp(emoji, "g");
        const match = text.match(compoundRegex);
        if (match) {
          compoundEmojiCount += match.length;
          // Remove matched compound emojis from text to prevent double-counting
          text = text.replace(compoundRegex, "");
        }
      });

      // Count remaining emojis with regex
      const matches = text.match(emojiRegex);
      let emojiCount = matches ? matches.length : 0;

      // Calculate non-emoji characters
      let nonEmojiText = text.replace(emojiRegex, "").normalize("NFC").trim();
      let nonEmojiCount = nonEmojiText.length;

      // Total count: compound emojis + other emojis + non-emoji characters
      return compoundEmojiCount + emojiCount + nonEmojiCount;
    },
    [] // Add any dependencies required
  );

  // Formats a given value to two decimal places, ensuring it is treated as a number.
  const formatToTwoDecimals = (value) => {
    // Ensure the value is a number before calling toFixed
    return (typeof value === "number" ? value : parseFloat(value)).toFixed(2);
  };

  // Inmate Name Selectbox - onChange event
  const handleSelectChange = (selectedOption, fieldName, isPhoto) => {
    //setShowCreditsAndMessageCost(true);
    setErrors((prev) => ({
      ...prev,
      [fieldName]: "", // Clear the specific field error
    }));

    if (selectedOption?.value === undefined) {
      setShowCreditsAndMessageCost(false);
      setCreditBalance((prevState) => ({
        ...prevState, // Spread previous state
        IsEmojiEnabled: false, // Update specific property
      }));
    }
    const selectedValue = Array.isArray(selectedOption)
      ? selectedOption.map((option) => option.value)
      : selectedOption?.value ?? "";
    setEcard((prevState) => ({
      ...prevState,
      [fieldName]: selectedValue,
    }));

    if (fieldName === "inmateID") {
      setSelectInmateId(selectedValue);
    }

    if (selectedValue !== "") {
      dispatch(
        writeMessageActions.getCategoryPublicCreditBalance({
          userId: userID,
          inmatesId: selectedValue,
          CategoryId: ecardInfo?.CategoryId,
        })
      ).then((response) => {
        if (response?.meta?.requestStatus === "fulfilled") {
          // The action was successful
          setShowCreditsAndMessageCost(true);
          let data = response?.payload;
          const formattedBalance = Object.keys(data).reduce((acc, key) => {
            acc[key] =
              typeof response?.payload[key] === "number" ||
                !isNaN(response?.payload[key])
                ? formatToTwoDecimals(response?.payload[key])
                : response.payload[key];
            return acc;
          }, {});

          let formatValue = formattedBalance[0];

          setEcard((prevState) => ({
            ...prevState,
            facilityId: formatValue?.FacilityID,
          }));

          if (isPhoto && formatValue?.CreditBalance === 0) {
            setisCreditamountModal(true);
            setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Card);
          }
          let ECardCost = ecardInfo?.CostCategory != 0 ? ecardInfo?.CostCategory : formatValue?.FacilityEcardCost
          if (
            isPhoto &&
            formatValue?.CreditBalance < ECardCost
          ) {
            setisCreditamountModal(true);
            setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Card);
          }
          setCreditBalance({
            ...formatValue,
            CreditBalance: parseFloat(formatValue?.CreditBalance ?? 0),
            FacilityEmojiCost: parseFloat(
              formatValue?.IsEmojiEnabled
                ? formatValue?.FacilityEmojiCost ?? 0
                : 0
            ),
            FacilityMessageCost: parseFloat(
              formatValue?.FacilityMessageCost ?? 0
            ),
            FacilityPhotoCost: parseFloat(formatValue?.FacilityPhotoCost ?? 0),
            FacilityEcardCost: parseFloat(ECardCost ?? 0),
            IsEmojiEnabled: formatValue?.IsEmojiEnabled ?? false,
          });
          setEcardCost(parseFloat(ECardCost ?? 0)
          );
        } else {
          // The action failed
          // console.error("Error:", response.error.message);
        }
      });
      //  let data = {
      //    messageKeyword: "",
      //    facilityID: formatValue?.FacilityID,
      //    webUserSentAction: "",
      //    inmateSentAction: "",
      //    keyWordFilterType: "",
      //    activeStatus: 2,
      //    pageNo: 1,
      //    rowCountPerPage: 50,
      //    sortBy: "MessageKeyWord Desc"
      //  };
      //  dispatch(
      //    writeMessageActions.LoadKeywordList(data)
      //  ).then((response) => {
      //    setKeywords(response?.payload?.DataList);
      //  })
    } else {
      // The action failed
      // console.error("Error:", response.error.message);
    }
  };

  const handleEmojiSelectEcard = (emoji, field) => {
    const maxLength = field === "messageBody" ? 2000 : 50; // Define the max length for each field

    const insertAtCaret = (text, emoji, inputRef) => {
      const input = inputRef.current;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      // Insert the emoji at the caret position
      const newText = text.slice(0, start) + emoji + text.slice(end);
      prevValueRef.current = newText;
      // Move the caret position after the emoji
      setTimeout(() => {
        input.selectionStart = input.selectionEnd = start + emoji.length;
      }, 0);

      return newText;
    };

    setEcard((prevState) => {
      // const newValue = prevState[field] + emoji; // Add emoji to the specified field
      const inputRef = subjectInputRef;

      const newValue = insertAtCaret(prevState[field], emoji, inputRef);
      // Ensure that the field value does not exceed the maximum length
      if (getDisplayLength(newValue) <= maxLength) {
        return {
          ...prevState,
          [field]: newValue,
        };
      }
      // If the value exceeds the maxLength, return the previous state
      return prevState;
    });
    // Focus the appropriate input field after adding the emoji
    if (field === "ecardSubject") {
      subjectInputRef?.current?.focus();
    }
  };

  // ------------------------------ Calculate E-card Cost (Total & Emoji Cost) -------------------------------------------
  const calculateEcardCost = useCallback(
    (message, FacilityEcardCost, FacilityEmojiCost) => {

      // Track unique emojis in a Set for simplicity
      const uniqueEmojis = new Set();
      const matches = checkEmojiRegex(message);
      if (matches) {
        setEcard((prevState) => ({
          ...prevState,
          isEmojiUsed: true,
        }));
        matches.forEach((emoji) => uniqueEmojis.add(emoji));
      } else {
        setEcard((prevState) => ({
          ...prevState,
          isEmojiUsed: false,
        }));
      }

      // Calculate costs
      const emojiCostTotal = uniqueEmojis.size * (FacilityEmojiCost || 0);
      const ecardCost = FacilityEcardCost || 0; // Photocost Need to change as EcardCost
      const totalCost = ecardCost + emojiCostTotal; // Photocost Need to change as EcardCost

      // Set state with formatted cost values
      setEcard((prevState) => ({
        ...prevState,
        totalEcardCost: totalCost.toFixed(2),
        totalEmojiCost: emojiCostTotal.toFixed(2),
      }));
    },
    [creditBalance]
  );


  const checkRestrictedKeywords = async () => {
    var result = await LoadQuarantineWords(ecard?.ecardSubject, ecard?.facilityId)
    if (result?.isQuarantineWords) {
      const restrictionMessage = `${currentLang?.Restricted_words} "${result?.keywordList}". ${currentLang?.Please_Remove}`;
      setFoundKeyword(restrictionMessage);
      setKeywordPopup(true);
      return false; //
    }
    else {
      setKeywordPopup(false);
      return true; // ✅ Proceed
    }
  };


  const removeDuplicates = (arr) => {
    const unique = [];
    const emojiRegex = /\p{Emoji}/u;
    arr.forEach(element => {
      if (emojiRegex.test(element) && !unique.includes(element)) {
        unique.push(element);
      }
    });
    return unique;
  };

  const isEmojiEnableCheck = async (ecard) => {
    const msgContent = ecard?.ecardSubject || '';
    const cleanedMsgContent = msgContent.replace(/[0-9#]/g, '');
    const splitter = new GraphemeSplitter();
    const graphemes = splitter.splitGraphemes(cleanedMsgContent);
    const uniqueEmojis = removeDuplicates(graphemes);
    const uniqueEmojiCount = uniqueEmojis?.length || 0;

    dispatch(
      writeMessageActions.getCategoryPublicCreditBalance({
        userId: ecard?.publicUserID,
        inmatesId: ecard?.inmateID,
        CategoryId: ecardInfo?.CategoryId,
      })
    ).then((response) => {
      if (response?.payload?.length > 0) {
        hideLoader()
        let ECardCost = response?.payload[0]?.CategoryCost != 0 ? response?.payload[0]?.CategoryCost : response?.payload[0]?.FacilityEcardCost
        setEcardCost(parseFloat(ECardCost ?? 0))
        let EmojiCost = response?.payload[0]?.FacilityEmojiCost || 0;
        setCreditBalance((preState) => ({ ...preState, FacilityEmojiCost: EmojiCost, }));
        if (response?.payload[0]?.IsEmojiEnabled == false && uniqueEmojiCount > 0) {
          setPaymentMsg(currentLang?.ECardPopContent?.No_Longer_Emoji_Access);
          setIsPaymentMsg(true);
          return false;
        }
        else {
          setSendEcardConfirmation(true);
          setShouldDisplayHTMLMessage(true);
          let text = ecard?.ecardSubject;
          // const message = "Hello 😏😏👨‍👩‍👧‍👦👨‍👩‍👧‍👦👨‍👩‍👧‍👦";
          const costDetails = calculateEcardCost(
            text,
            parseFloat(ECardCost), // Need to change after API Complete (FacilityEcardCost)
            EmojiCost
          );
          // }
          // });
        }
      }
      else {
        hideLoader()
        setSendEcardConfirmation(true);
        setShouldDisplayHTMLMessage(true);
        let text = ecard?.ecardSubject;
        // const message = "Hello 😏😏👨‍👩‍👧‍👦👨‍👩‍👧‍👦👨‍👩‍👧‍👦";
        const costDetails = calculateEcardCost(
          text,
          parseFloat(ecardCost), // Need to change after API Complete (FacilityEcardCost)
          creditBalance?.FacilityEmojiCost
        );
      }
    });

  };

  // Handle E-card Send Validation
  const handleEcardSendValidation = async (e) => {
    e?.preventDefault();
    setErrors({});

    if (card?.EcardId) {
      setEcard((preState) => ({
        ...preState,
        ecardId: card?.EcardId,
      }));
    }

    if (document?.getElementsByClassName("border-danger").length !== 0) {
      document
        .querySelectorAll(".border-danger")
        .forEach((el) => el.classList.remove("border-danger"));
    }
    const { error } = sendEcardSchema(ecard);
    if (error?.details) {
      error.details.map((e) => {
        const { path } = e;
        // Update the errors state
        setErrors((prev) => ({
          ...prev,
          [path[0]]: e.message,
        }));

        // Select both input and textarea elements by name
        document
          .querySelector(`input[name=${path[0]}]`)
          ?.classList.add("border-danger");
      });
      return;
    } else {
      showLoader();
      const isAllowed = await checkRestrictedKeywords();
      if (!isAllowed) { hideLoader(); return; }

      await isEmojiEnableCheck(ecard);

    }
  };

  const handleEcardSend = (e) => {
    setSendEcardConfirmation(false);
    setShouldDisplayHTMLMessage(false);
    // } else {
    showLoader();
    dispatch(writeMessageActions.SendEcardFromPublicUser({
      ...ecard, envelopecolor: envelopecolor,
      ecardbgcolor: ecardbgcolor,
      rippencolor: rippencolor
    })).then(
      (response) => {
        setenvelopecolor(""); setecardbgcolor(""); setrippencolor(""); setCustomized(false);
        ///dispatch(writeMessageActions?.clearSelectedCategories());
        if (response?.meta?.requestStatus === "fulfilled") {
          hideLoader();
          let status = response?.payload;
          switch (status) {
            case 1:
              NotificationService({
                title: currentLang?.Success,
                message: currentLang?.ECardPopContent?.ECard_sent_Success,
                type: "success",
              });
              handleEcardReset();
              break;
            case -1:
              NotificationService({
                title: currentLang?.Warning,
                message: currentLang?.ECardPopContent?.ECard_sent_Failed,
                type: "warning",
              });
              break;
            case -2:
              // NotificationService({
              //   title: "Warning",
              //   message: "COD Photo",
              //   type: "warning",
              // });
              setisCreditamountModal(true);
              setMsgCreditamount(currentLang?.ECardPopContent?.Low_balance_Card);
              handleEcardReset();
              break;
            case -3:
              NotificationService({
                title: currentLang?.Warning,
                message: currentLang?.ECardPopContent?.Repeated_Conversation,
                type: "warning",
              });
              // handleEcardReset();
              break;
            case -4:
              // setPaymentMsg("Public User Inmate connection is Inactiv");
              setPaymentMsg(currentLang?.ECardPopContent?.connection_Blocked,);
              setIsPaymentMsg(true);
              handleEcardReset();
              var data = {
                publicUserID: userID,
                inmateID: 0,
                connectionStatus: 2,
                purpose: "Ecard",
                sortBy: "",
              };
              dispatch(writeMessageActions.LoadPublicMyContactsDisplayEcard(data))
                .then((res) => {
                  setInmateList(res?.payload || []);
                })
              // dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
              //   loadInmateDetails("Photo"); // Need to change Ecard
              break;
            // case -5:
            //   setPaymentMsg("Deactivated Public User Account");
            //   setIsPaymentMsg(true);
            //   // dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
            //   //   loadInmateDetails("Photo"); // Need to change Ecard
            //   break;
            case -6:
              setPaymentMsg(currentLang?.ECardPopContent?.No_Permission,);
              setIsPaymentMsg(true);
              //  dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
              //   loadInmateDetails("Photo"); // Need to change Ecard
              handleEcardReset();
              break;
            case -5:
            case -7:
              setPaymentMsg(currentLang?.ECardPopContent?.connection_Blocked,);
              setIsPaymentMsg(true);
              handleEcardReset();
              var data = {
                publicUserID: userID,
                inmateID: 0,
                connectionStatus: 2,
                purpose: "Ecard",
                sortBy: "",
              };
              dispatch(writeMessageActions.LoadPublicMyContactsDisplayEcard(data))
                .then((res) => {
                  setInmateList(res?.payload || []);
                })
              // dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
              //   loadInmateDetails("Photo"); // Need to change Ecard
              break;
            case -8:
              setPaymentMsg(currentLang?.ECardPopContent?.No_longer_connected,);
              setIsPaymentMsg(true);
              //  dispatch(myContactsActions.clearPublicMyContactsDisplayNew());
              //  loadInmateDetails("Photo"); // Need to change Ecard
              break;
            default:
              setPaymentMsg(currentLang?.ECardPopContent?.Something_went_wrong,);
              setIsPaymentMsg(true);
              break;
          }
        }
      }
    );
  };

  // Clear Ecard Tab
  // Clear Send Photo Tab
  const handleEcardReset = () => {
    setCustomized(false);
    setenvelopecolor("");
    setecardbgcolor("");
    setrippencolor("");
    prevValueRef.current = "";
    showLoader();
    // setIsFullScreen(false);
    setEcard(initialSendEcard);
    setRotation(0);
    // setEcardImages([]);
    // setSelectedEcard(null);
    //  setIsDisabledInmateID(false);
    setEcardInmateID(null);
    setShowCreditsAndMessageCost(false);
    // {creditBalance?.IsEmojiEnabled === true && (
    setCreditBalance((prevState) => ({
      ...prevState, // Spread previous state
      IsEmojiEnabled: false, // Update specific property
    }));

    setErrors({});
    document
      .querySelectorAll(".border-danger")
      .forEach((el) => el.classList.remove("border-danger"));
    hideLoader();
  };

  const handleClickRedirect = () => {
    showLoader();
    dispatch(
      sendPhotosActions.CheckingMsgPhotoStatus({
        addFormData: { UserID: userID, InmateID: ecard?.inmateID !== 0 ? ecard?.inmateID : selectinmateId },
      })
    );

    // EventLog - For track COD Message/ Photo Send
    CreateEventLogTextFileForInbox(
      dispatch,
      `Write Message / Photo menu - COD E-Card sent, navigating to Purchase History page`,
      "---",
      "---",
      `User submitted COD E-Card. Redirected to Purchase History.`
    );

    hideLoader();
  };

  // Purchase Credit Status -------------------------------------------------------
  useEffect(() => {
    if (MsgPhotoStatusResponse) {
      const { Result, Notes } = MsgPhotoStatusResponse;
      switch (Result) {
        case -7:
          setPaymentMsg(currentLang?.ECardPopContent?.Connection_BlockedBY_Admin);
          setIsPaymentMsg(true);
          handleEcardReset();
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -8:
          setPaymentMsg(currentLang?.ECardPopContent?.No_longer_connected);
          setIsPaymentMsg(true);
          handleEcardReset();
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -6:
          setPaymentMsg(currentLang?.ECardPopContent?.Disabled_Contact);
          setIsPaymentMsg(true);
          handleEcardReset();
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -4:
          setPaymentMsg(currentLang?.ECardPopContent?.Disabled_Facility);
          setIsPaymentMsg(true);
          handleEcardReset();
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        case -3:
          setPaymentMsg(Notes);
          setIsPaymentMsg(true);
          handleEcardReset();
          dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          break;
        default:
          if (Result === 0) {
            // If success response (result = 0), redirect
            setStoredValue("InmateID", ecard?.inmateID !== 0 ? ecard?.inmateID : selectinmateId);
            navigate("/public/PurchaseCredits", {
              state: { previousPath: location.pathname },
            });
            storeCurrentRoute("/public/PurchaseCredits");
            dispatch(sendPhotosActions.clearMsgPhotoStatusResponse());
          }
          break;
      }
      setisCreditamountModal(false);
    }
  }, [MsgPhotoStatusResponse]);

  return (
    <>
      {" "}
      <ReactNotifications />
      <div className="container-fluid p-2 p-md-4">
        {loader}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <h4 className="mb-2 mb-md-0 fw-bold text-center text-md-start">
            {currentLang?.sentECards?.ECARD}
          </h4>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <button className="btn btn-danger mt-2 mt-md-0" onClick={handleBackClick}>
              {currentLang?.buttons?.Back}
            </button>
          </div>
        </div>

        <div className="bg-white p-4 rounded shadow-sm row g-4" style={{ marginTop: 'auto' }}>
          {/* E-Card Image Section - Improved Responsive Handling */}
          <div className="col-12 col-md-12 col-lg-6">
            <div className="ecard-image-container">
              {ecardInfo?.EcardFilePath && (
                <div className={!customized ? "ecard-image-wrapper" : ""}>
                  <CustomEcard
                    envelopecolor={envelopecolor}
                    ecardbgcolor={ecardbgcolor}
                    rippencolor={rippencolor}
                    setenvelopecolor={setenvelopecolor}
                    setecardbgcolor={setecardbgcolor}
                    setrippencolor={setrippencolor}
                    customized={customized}
                    setCustomized={setCustomized}
                    rotation={rotation}
                    setRotation={setRotation}
                    setLoading={setLoading}
                    imgsrc={`${process.env.REACT_APP_API_IMAGE_URL}${ecardInfo?.EcardFilePath}`}
                    isimgrotation={true}
                    showLoader={showLoader}
                    issendECard={true}
                    hideLoader={hideLoader}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Form Section */}
          <div className="col-12 col-md-12 col-lg-6" style={{ minWidth: 0 }}>
            {/* ... rest of your form JSX remains the same ... */}
            <div className="mb-3">
              <SelectInput
                options={inmateList}
                value={ecard?.inmateID}
                onChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "inmateID", true)
                }
                name="inmateID"
                labelKey="label"
                valueKey="value"
                isMulti={false}
                isDisabled={EcardInmateID ? true : false}
                closeMenuOnSelect={true}
                isClearable={true}
                placeholder={currentLang?.sentECards?.Select_Inmate}
                label={currentLang?.sentECards?.Inmate_Name}
                required={true}
                handleBlur={null}
                errorMessage={errors?.inmateID}
              />
            </div>

            {showCreditsAndMessageCost && (
              <div className="d-flex flex-wrap align-items-start fs-5 mb-2 gap-2">
                <p className="me-3 fs-14">
                  {currentLang?.AvailableCredits}{" "}
                  <strong
                    className={`ms-0 ${creditBalance?.CreditBalance === 0 ||
                      creditBalance?.FacilityEcardCost > creditBalance?.CreditBalance
                      ? "text-danger"
                      : "txt-success"
                      }`}
                  >
                    ${creditBalance?.CreditBalance?.toFixed(2)}
                  </strong>
                </p>
                <p className="me-3 fs-14">
                  {currentLang?.ECard_Cost}{" "}
                  <strong className="ms-0 txt-success">
                    ${Number(ecardCost).toFixed(2)}
                  </strong>
                </p>
                {creditBalance?.IsEmojiEnabled === true && (
                  <>
                    <p className="me-3 fs-14">
                      {currentLang?.Emoji_Cost}{" "}
                      <strong className="ms-0 txt-success">
                        ${creditBalance?.FacilityEmojiCost.toFixed(2)}
                      </strong>
                      <i
                        className="fa fa-info-circle"
                        title={currentLang?.InboxPopContent?.Same_Emoji}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </p>
                  </>
                )}
              </div>
            )}

            <div className="position-relative mb-3">
              <label className="form-label w-100 fs-5 inmate-label">
                {currentLang?.sentECards?.Subject}{" "}
                <span className="text-danger">*</span>
              </label>
              <div className="position-relative">
                <input
                  type="text"
                  inputMode="text"
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck={false}
                  onKeyDown={(e) => {
                    restrictCharacters(e);
                    handleKeyDownPhoto(e);
                  }}
                  onClick={handleInputClick}
                  ref={subjectInputRef}
                  className="form-control mb-1 fs-5 fw-normal pe-5"
                  value={ecard?.ecardSubject}
                  onChange={(e) => handleChange(e, false)}
                  name="ecardSubject"
                  onCopy={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onFocus={handleSubjectFocus}
                  onBlur={handleSubjectBlur}
                  placeholder={currentLang?.sentECards?.Subject}
                  errorMessage={errors?.ecardSubject}
                />
                {creditBalance?.IsEmojiEnabled === true && (
                  <span
                    className="position-absolute end-0 top-50 translate-middle-y me-3 fs-5 animated-emoji"
                    onClick={() => handleIconClick("subject")}
                  >
                    😊
                  </span>
                )}
              </div>
              <div className="text-danger fw-700 fs-6 mb-20px mt-1">
                {errors && errors["ecardSubject"]}
              </div>
              {isSubjectIconPickerOpen && isSubjectFocused && (
                <div
                  className="dropdown-menu show p-2 overflow-auto"
                  ref={emojiPickerRef}
                  tabIndex={-1}
                  onMouseDown={(e) => {
                    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                    if (isIOS) {
                      e.preventDefault();
                    }
                  }}
                >
                  <EmojiPicker
                    onEmojiSelect={(emoji) =>
                      handleEmojiSelectEcard(emoji, "ecardSubject")
                    }
                    onClose={() => setIsSubjectIconPickerOpen(false)}
                  />
                </div>
              )}
            </div>

            <div className="d-flex flex-column flex-sm-row gap-2">
              <button
                className="btn btn-danger me-2 font-size-14 mb-2"
                disabled={customized}
                onClick={() => {
                  setCustomized(true); setenvelopecolor("#6c6ca8");
                  setecardbgcolor("#d8d8fb");
                  setrippencolor("#ff3b3b");
                }}
              >
                <i className="fa-solid fa-pen me-1"></i>
                {"CUSTOMIZE"}
              </button>
              <button
                className="btn button-success me-2 font-size-14 mb-2"
                onClick={handleEcardSendValidation}
              >
                <i className="fa-regular fa-paper-plane me-1"></i>
                {currentLang?.buttons?.Send}
              </button>
              <button
                className="btn btn-grey font-size-14 mb-2"
                onClick={handleEcardReset}
              >
                <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                {currentLang?.buttons?.Reset}
              </button>
            </div>

            <div className="row mt-3">
              <div className="col-12">
                <p className="fs-5 no-expectation-text">
                  <strong className="text-danger">*</strong>
                  {currentLang?.Msg_Notice_Content}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Modals remain the same */}
        <ConfirmationModal
          show={isCreditamountModal}
          onConfirm={handleClickRedirect}
          title={currentLang?.Message}
          message={msgCreditamount}
          showCancelButton={false}
          messageColor="#FF7F7F"
          size={"lg"}
          onconfirmname={currentLang?.buttons?.OK}
          closeButton={false}
        />
        <ConfirmationModal
          show={SendEcardConfirmation}
          onHide={() => {
            setSendEcardConfirmation(false);
          }}
          onConfirm={handleEcardSend}
          title={currentLang?.Message}
          messageHTML={
            shouldDisplayHTMLMessage && ecard?.totalEmojiCost > 0
              ? `${currentLang?.ECardPopContent?.ECard_sent_Confirm} </br>
                     ${currentLang?.Total_Cost} <b style="color:${ecard?.totalEcardCost > 0 ? "#4a9a93" : "#C8605E"
              };">$${ecard?.totalEcardCost}</b> 
                       (${currentLang?.ECard_Cost} <b style="color:${creditBalance?.FacilityEcardCost > 0 ? "#4a9a93" : "#C8605E"
              };">$${parseFloat(ecardCost).toFixed(2)}</b> 
                       + ${currentLang?.Emoji_Cost} <b style="color:${ecard?.totalEmojiCost > 0 ? "#4a9a93" : "#C8605E"
              };">$${ecard?.totalEmojiCost}</b>)`
              : null
          }
          message={currentLang?.ECardPopContent?.ECard_sent_Confirm}
          closeButton={false}
          onconfirmname={currentLang?.buttons?.Yes}
          oncancelname={currentLang?.buttons?.No}
        />
        <ConfirmationModal
          show={isPaymentMsg}
          onHide={() => setIsPaymentMsg(false)}
          onConfirm={() => setIsPaymentMsg(false)}
          title={currentLang?.Message}
          message={paymentMsg}
          showCancelButton={false}
          onconfirmname={currentLang?.buttons?.OK}
        />
        <ConfirmationModal
          show={keywordPopup}
          onHide={() => setKeywordPopup(false)}
          onConfirm={() => setKeywordPopup(false)}
          title={currentLang?.Message}
          message={foundKeyword}
          onconfirmname={currentLang?.buttons?.OK}
          closeButton={false}
          showCancelButton={false}
        />
      </div>



    </>
  );
};

export default React.memo(SendECard);
